
import events from 'dom/events.js';
import select from 'dom/select.js';

/* Images have a background until they are loaded. We wait for document load
   simply to allow the slide-show time to duplicate its slides, otherwise they
   are duplicated with a loading class, but no handler is bound here to remove
   that loading class. A Bit Pants. */

events('load', window).each(() => {
    select('.loading', document.body)
    .forEach((element) => {
        if (element.complete) {
            element.classList.remove('loading');
            return;
        }

        element.onload = () => element.classList.remove('loading');
    });
})
